import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthFacade } from '../../authentication/data-access/facades/auth.facade';

/**
 * En MainLayout: si el JWT exige cambio de contraseña, solo permite
 * `/auth/cambiar-contrasena`.
 */
export const passwordChangeRequiredGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  if (authFacade.mustChangePassword()) {
    return router.parseUrl('/auth/cambiar-contrasena');
  }
  return true;
};

/**
 * En la pantalla de cambio de contraseña: exige sesión.
 * Si llega desde el correo del alta sin sesión, el ingreso lo devuelve aquí.
 */
export const changePasswordPageGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  if (!authFacade.isAuthenticated()) {
    return router.createUrlTree(['/auth/ingresar'], {
      queryParams: { returnUrl: '/auth/cambiar-contrasena' },
    });
  }
  return true;
};
